import React from 'react';
import { NavBar } from '../../../Modules/Navigation/components/NavBar/NavBar';
import SongCollectionTracker from '../../../Modules/SongCollection/features/SongCollectionTracker/SongCollectionTracker';

const SongCollectionsPage = () => (
    <>
        <NavBar />
        <SongCollectionTracker />
    </>
);

export default SongCollectionsPage;
